import { render, staticRenderFns } from "./SpaceManager.vue?vue&type=template&id=91bea5b8&scoped=true"
import script from "./SpaceManager.vue?vue&type=script&lang=js"
export * from "./SpaceManager.vue?vue&type=script&lang=js"
import style0 from "./SpaceManager.vue?vue&type=style&index=0&id=91bea5b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91bea5b8",
  null
  
)

export default component.exports